import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Clarity from '@microsoft/clarity';

import App from './App';
import { TeamsProvider } from './context/TeamsProvider';
import { initNetworkInterceptor } from './utils/networkInterceptor';

// Initialize network interceptor for debugging
initNetworkInterceptor();

const Root = () => {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  Clarity.init(projectId);

  return (
    <Router>
      <TeamsProvider>
        <App />
      </TeamsProvider>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);
